import IcCloseBold from './IcCloseBold'

export default IcCloseBold
